import React, { useEffect } from "react";
import PageTitle from "../assets/images/city-image-navigation.jpeg";
import ImgNasilCalisir1 from "../assets/images/nasilcalisir_01.png";
import ImgNasilCalisir2 from "../assets/images/nasilcalisir_02.png";
import ImgNasilCalisir3 from "../assets/images/nasilcalisir_03.png";
import ImgNasilCalisir4 from "../assets/images/nasilcalisir_04.png";
import ImgNasilCalisir5 from "../assets/images/nasilcalisir_05.png";
import ImgNasilCalisir6 from "../assets/images/nasilcalisir_06.png";
import ImgNasilCalisir7 from "../assets/images/nasilcalisir_07.png";
import ImgNasilCalisir8 from "../assets/images/nasilcalisir_08.png";
import ImgHandshake from "../assets/images/hand-shake-icon.png";
import ImgDeliveryTruck from "../assets/images/delivery-truck-icon.png";
import ImgServiceProvider from "../assets/images/service-provider-icon.png";
import ImgFuelPump from "../assets/images/fuel-pump-icon.png";
import ImgCloudData from "../assets/images/cloud-data-icon.png";
import ImgAtm from "../assets/images/atm-icon.png";
import ImgCalendar from "../assets/images/calendar-icon.png";
import ImgTTS from "../assets/images/tts-icon-1.png";
import steps from "../data/steps";

export default function NasilCalisir() {
  const images: any[] = [];
  useEffect(() => {
    for (let i = 1; i <= 8; ++i) {
      import(`../assets/images/nasilcalisir_0${i}.png`)
        .then((item) => images.push(item))
        .catch((err) => console.log(err));
    }
  }, [images.length]);

  return (
    <div className="container-fluid animate pageWrapper">
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}

        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>NASIL &#199;ALIŞIR</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"}{" "}
                  <a href="#">NASIL &#199;ALIŞIR</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}

        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textCapsule">
                <h2 className="title">
                  <b>Shell Taşıt Tanıma Sistemi</b>
                  <br />
                  <span className="red big">
                    <b>NASIL ÇALIŞIR</b>
                  </span>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--baslik--> */}
            <div className="row mt-3 center-xs">
              <div className="col-xs-12">
                <div className="textCapsule">
                  <h3>8 ADIMDA TAŞIT TANIMA SİSTEMİ</h3>
                </div>
              </div>
            </div>
            {/* <!--/baslik--> */}
            {/* <!--adımlar--> */}
            {steps.map((step, index) => (
              <div key={index} className="row middle-xs">
                <div className="col-xs-12 mb-1">
                  <hr />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                  <span className="textCapsule">
                    <p>
                      <img src={step.img} height="210" width="210" />
                    </p>
                  </span>
                </div>
                <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                  <span className="textCapsule">
                    <h4>{step.step}.ADIM</h4>
                    <p>{step.title}</p>
                    {step.step === 2 && (
                      <p className="twoStepButton">
                        <a
                          href="/portal/utts-montaj-basvuru"
                          className="file"
                        >
                          Kit-Tak Servis Noktaları
                        </a>
                      </p>
                    )}
                  </span>
                </div>
              </div>
            ))}
            {false && (
              <>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <span className="textCapsule">
                      <p>
                        <img src={ImgHandshake} height="210" width="210" />
                      </p>
                    </span>
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>1.ADIM</h4>
                      <p>
                        Satış temsilcimiz ile müşterimiz, Taşıt Tanıma
                        Sistemi'ne dahil olma konusunda anlaşmaya varır ve
                        ilgili sözleşme karşılıklı olarak onaylanır.
                      </p>
                    </span>
                  </div>
                </div>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <span className="textCapsule">
                      <p>
                        <img src={ImgDeliveryTruck} alt="" />
                      </p>
                    </span>
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>2.ADIM</h4>
                      <p>
                        İstenilen akıllı anahtarlık, müşterinin adresine kargo
                        yoluyla ulaştırılır.
                      </p>
                    </span>
                  </div>
                </div>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <span className="textCapsule">
                      <p>
                        <img
                          src={ImgServiceProvider}
                          height="210"
                          width="210"
                        />
                      </p>
                    </span>
                    {/* 
                <div className="imgCapsule">
                  <img src={ImgFastDelivery} alt="adim3" />
                </div> */}
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>3.ADIM</h4>
                      <p>
                        Eğer akıllı halka ünitesi istenmişse, en yakın Turpak
                        Servisi ücretsiz montajı gerçekleştirir. Dört veya daha
                        fazla araç için ise, Turpak ekibi randevu ile
                        bulunduğunuz yerde montaj yapar.
                      </p>
                      <p>
                        <a
                          href="/file/turpak-regional-service-list-coorded-shell-dec.xlsx"
                          download="turpak-regional-service-list-coorded-shell-dec.xlsx"
                          className="file"
                        >
                          TTS Servis Noktaları
                        </a>
                      </p>
                    </span>
                  </div>
                </div>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <div className="textCapsule">
                      <img src={ImgFuelPump} height="210" width="210" />
                    </div>
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>4.ADIM</h4>
                      <p>
                        İstasyondaki görevli, aracın arka camındaki TTS etiketi
                        sayesinde aracı tanır ve uygun TTS pompasına
                        yönlendirir.
                      </p>
                    </span>
                  </div>
                </div>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <span className="textCapsule">
                      <p>
                        <img src={ImgCloudData} height="210" width="210" />
                      </p>
                    </span>
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>5.ADIM</h4>
                      <p>
                        Yakıt alımı sırasında Taşıt Tanıma Ünitesi, pompa ile
                        iletişim kurar. Yakıt tipi, miktarı ve dolum zamanı
                        Shell'in merkezi sistemine kaydedilir ve bilgiler
                        istasyona aktarılır.
                      </p>
                    </span>
                  </div>
                </div>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <span className="textCapsule">
                      <p>
                        <img src={ImgAtm} height="210" width="210" />
                      </p>
                    </span>
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>6.ADIM</h4>
                      <p>
                        Dolum işlemi bittiğinde, makbuz otomatik olarak
                        yazdırılır ve istasyon çalışanı tarafından sürücüye
                        verilir. Sürücü, makbuzunu aldıktan sonra yoluna devam
                        edebilir.
                      </p>
                    </span>
                  </div>
                </div>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <span className="textCapsule">
                      <p>
                        <img src={ImgCalendar} height="210" width="210" />
                      </p>
                    </span>
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>7.ADIM</h4>
                      <p>
                        Sisteme dahil olan araçların yakıt harcamaları, her ayın
                        15'inde ve sonunda faturalandırılır. Faturalarınızı,
                        firmanızın ödeme süreçlerine uygun şekilde kolayca
                        ödeyebilirsiniz.
                      </p>
                    </span>
                  </div>
                </div>
                <div className="row middle-xs">
                  <div className="col-xs-12 mb-1">
                    <hr />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-3 col-xm-3 col-xs-4">
                    <span className="textCapsule">
                      <p>
                        <img src={ImgTTS} height="210" width="210" />
                      </p>
                    </span>
                  </div>
                  <div className="col-lg-10 col-md-10 col-sm-9 col-xm-9 col-xs-8">
                    <span className="textCapsule">
                      <h4>8.ADIM</h4>
                      <p>
                        Taşıt Tanıma Sistemi'ne dair tüm işlemlerinizi, internet
                        erişimi olan her yerden kolayca gerçekleştirebilirsiniz.
                      </p>
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {/* <!--/page--> */}
      </div>
    </div>
  );
}
